import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { resetAnalytics, markInternal } from "@/lib/analytics";
import { setCurrency } from "@/lib/format";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => { if (user?.role === "admin") markInternal(); }, [user]);
  setCurrency(user?.restaurant?.currency || "EUR");

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
    const onLogout = () => setUser(false);
    window.addEventListener("auth:logout", onLogout);
    return () => window.removeEventListener("auth:logout", onLogout);
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    resetAnalytics();
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, loadMe }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
